module.exports = "https://img1.huilianyi.com/5/icon5.5818112508.appcore.png";